import { useCallback, useEffect, useRef } from 'react';

import { api, API } from 'modules/api';
import { AchievementsTypes } from '../types';
import { BadgesTypes } from 'pages/badges/types';
import logger from 'modules/logger';

export const useUpdateBadges = (
  setAchievements: React.Dispatch<
    React.SetStateAction<AchievementsTypes[] | undefined>
  >,
  setBadges: React.Dispatch<React.SetStateAction<BadgesTypes[] | undefined>>,
  cancelPolling: () => void,
  runPolling: (
    badges: BadgesTypes[],
    setBadges: React.Dispatch<React.SetStateAction<BadgesTypes[] | undefined>>,
  ) => void,
) => {
  const active = useRef(true);
  //TODO done useCallback
  const updateBadges = useCallback(async () => {
    try {
      api(API.GET_BADGES_CERTIFICATE_PATHS()).then(achievementsResponse => {
        setAchievements(achievementsResponse.data);
      });

      api(API.GET_BADGES_STATUS()).then(badgesResponse => {
        setBadges(badgesResponse.data);
        runPolling(badgesResponse.data, setBadges);
      });

      if (active.current) {
        cancelPolling();
      }
    } catch (error) {
      active.current && logger.debug('Badges Response Error: ', error);
    }
  }, [cancelPolling, runPolling, setAchievements, setBadges]);

  useEffect(() => {
    return () => {
      active.current = false;
    };
  }, []);

  return { updateBadges };
};
